// 优惠券类型
export enum CouponTemplateType {
  LessonCoupon = 1, // 课次券
  OnlineCashCoupon = 2, // 线上课现金券
  MemberCardCashCoupon = 3, // 会员卡代金券
}

// 优惠券目标用户
export enum TargetUser {
  //新用户专享
  NEW = 2,
  //所有用户
  ALL = 1,
}

// 优惠券激活方式
export enum ActivationType {
  IMMEDIATELY = 1, // 发放后即可使用
  DELAY = 2, // 发放后延期
}

// 优惠券有效期
export enum VoucherValidTime {
  // 固定有效期
  FIXED = 1,
  // 发放后x天有效
  AFTER_DAYS = 2,
  // 发放后延期
  DELAY = 3,
}

// 优惠券发放状态
export enum CouponIssueStatus {
  Pending = 1, // 发放中
  Success = 2, // 发放成功
  Failed = 3, // 发放失败
}
